module.exports = __webpack_public_path__ + "img/lb_logo2.5ab75a08.png";